import React from "react";
import { Chip } from "@mui/material";
import { Entrada, Salida } from "assets/icons";
import { SEMAFORO_COLORS, ESTADO_LABELS } from "pages/migra/utils/usuarioPaso";

const TIPO_LABELS = { E: "Entrada", S: "Salida" };
const TIPO_ICONS = { E: Entrada, S: Salida };

function formatEvento(fechaCheckin) {
    if (!fechaCheckin) return '';
    const hora = fechaCheckin.slice(11, 16);
    return hora ?? '';
}

export const monitorColumns = [
    {
        field: "migraUsuarioPasoSemaforo",
        headerName: "Semáforo",
        width: 85,
        align: "center",
        headerAlign: "center",
        sortable: false,
        renderCell: ({ value }) => {
            const color = SEMAFORO_COLORS[value];
            if (!color) return null;
            return (
                <span
                    style={{
                        display: "inline-block",
                        width: 14,
                        height: 14,
                        borderRadius: "50%",
                        backgroundColor: color,
                    }}
                />
            );
        },
    },
    { field: "apellidoYNombre", headerName: "Apellido y Nombre", flex: 1.5, minWidth: 200, sortable: false },
    // { field: "tipoDeDocumentoCod", headerName: "Tipo de Doc.", width: 110, sortable: false },
    { field: "usuarioNroDeDocumentoX", headerName: "Documento", width: 100, align: "right", headerAlign: "right", sortable: false },
    { field: "migraPasoNombre", headerName: "Paso", flex: 1, minWidth: 150, sortable: false },
    {
        field: "migraUsuarioPasoTipo",
        headerName: "Tipo",
        width: 90,
        align: "center",
        headerAlign: "center",
        sortable: false,
        valueGetter: ({ value }) => TIPO_LABELS[value] ?? value ?? "",
    },
    {
        field: "migraUsuarioPasoEstado",
        headerName: "Estado",
        width: 100,
        sortable: false,
        valueGetter: ({ value }) => ESTADO_LABELS[value] ?? value ?? "",
    },
    { field: "migraUsuarioPasoIdentificacion", headerName: "Identificación", minWidth: 130, sortable: false },
    { field: "migraUsuarioPasoOrigenDestino", headerName: "Origen/Destino", minWidth: 130, sortable: false },
    {
        field: "migraUsuarioPasoFechaCheckin",
        headerName: "Evento",
        width: 120,
        align: "center",
        headerAlign: "center",
        sortable: false,
        renderCell: (params) => {
            if (params.row.migraUsuarioPasoEstado === "P") return '';
            const hora = formatEvento(params.value);
            if (!hora) return '';
            const Icon = TIPO_ICONS[params.row.migraUsuarioPasoTipo];
            return (
                <Chip
                    label={hora}
                    icon={Icon ? <img src={Icon} alt={params.row.migraUsuarioPasoTipo} style={{ width: 14, height: 14, marginLeft: 4 }} /> : undefined}
                    size="small"
                    variant="outlined"
                    color="primary"
                />
            );
        },
    },
];
